module.exports = __webpack_public_path__ + "static/media/facebook.372d7a21.svg";